import ReactDOM from "react-dom/client";
import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import { App } from "src/app";
import ErrorBoundary from "./components/error-boundary";
import { installErrorReporting } from "./utils/error-reporting";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

installErrorReporting();

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
